import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  name: '',
  minVolume: null,
  maxVolume: null,
  width: 0,
  height: 0,
  length: 0,
  weight: 0,
  externalId: '',
  warehouseId: '',
  brandId: ''
};

let defaultFilters = {
  name: '',
  brandId: '',
  warehouseId: '',
  externalId: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};